import { SignInContainer } from '@containers/auth';

export function SignIn() {
  return <SignInContainer />;
}
